export const myopAttributes = {
    id: 'myop-id'
}
